var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-all"},[_c('page-list',{ref:"listPage",attrs:{"tableRander":_vm.tableRander,"searchRander":_vm.searchRander,"headBtnsString":"deletes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }